import PropTypes from "prop-types";

// material-ui
import { useTheme } from "@mui/material/styles";
import { Avatar, Box, ButtonBase, Typography, Divider } from "@mui/material";

// project imports
import LogoSection from "../LogoSection";

// assets

import MenuIcon from "./menu-icon";

// ==============================|| MAIN NAVBAR / HEADER ||============================== //


const Header = ({
  handleLeftDrawerToggle,
  loggedin,
  groups,
  future_employer_email,
}) => {
  const theme = useTheme();
  const appBarStyle = {
    backgroundColor: "#0E1635",
    padding: "1rem",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  };

  const titleStyle = {
    flexGrow: 1,
    color: "white",
    fontSize: "1.5rem",
    fontWeight: "bold",
  };

  const buttonStyle = {
    marginLeft: "1rem",
    color: "white",
    backgroundColor: "rgb(234 0 0)",
    border: "none",
    padding: "0.5rem 1rem",
    cursor: "pointer",
    fontSize: "19px",
  };

  const signUpButtonStyle = {
    ...buttonStyle,
    backgroundColor: "rgb(234 0 0)",
    borderRadius: "30px",
  };
  const signInButtonStyle = {
    backgroundColor: "rgb(255, 100, 0)",
    color: "#ff6b00",
    borderColor: "rgb(255, 100, 0)",
    padding: "0.5rem 1rem",
    cursor: "pointer",
    fontSize: "19px",
    borderRadius: "30px",
    background: "transparent",
    borderRadius: "30px",
  };

  return (
    <>
      {/* logo & toggler button */}
      <Box
        sx={{
          width: 500, //228,
          display: "flex",
          [theme.breakpoints.down("md")]: {
            width: "auto",
          },
        }}
      >
        <Box
          component="span"
          //sx={{ display: { xs: "none", md: "block" }, flexGrow: 1 }}
          display={{ xs: "none", md: "flex" }}
          alignItems="center"
        >
          <LogoSection />
          {/* {!future_employer_email && groups.length && (
            <>
              <Divider
                orientation="vertical"
                flexItem
                sx={{ ml: 3, height: 50 }}
              />
              <Typography
                variant="p"
                component="div"
                sx={{ flexGrow: 1, mx: 2 }}
                style={{ color: "#FFFF", fontSize: "21px" }}
              >
                {groups[0].name} Dashboard
              </Typography>
            </>
          )} */}
        </Box>

        <ButtonBase sx={{ borderRadius: "12px", overflow: "hidden" }}>
          <Avatar
            variant="rounded"
            sx={{
              ...theme.typography.commonAvatar,
              ...theme.typography.mediumAvatar,
              transition: "all .2s ease-in-out",
              background: theme.palette.secondary.dark,
              color: theme.palette.secondary.light,
              "&:hover": {
                background: theme.palette.secondary.dark,
                color: theme.palette.secondary.light,
              },
            }}
            onClick={handleLeftDrawerToggle}
            color="inherit"
          >
            <MenuIcon />
          </Avatar>
        </ButtonBase>
      </Box>

      <Box sx={{ flexGrow: 1 }} />
      <Box sx={{ flexGrow: 1 }} />
      <Box sx={{ flexGrow: 1 }} />
      <Box
        sx={{
          width: 500, //228,
          display: "flex",
          [theme.breakpoints.down("md")]: {
            width: "auto",
          },
        }}
      >
        {!loggedin && (
          <Box
            component="span"
            sx={{ display: { xs: "none", md: "block" }, flexGrow: 1 }}
            // display={{ xs: "none", md: "flex" }}
            alignItems="center"
          >
            <LogoSection />
          </Box>
        )}
      </Box>
      <Box sx={{ flexGrow: 1 }} />
      <Box sx={{ flexGrow: 1 }} />
      {/* <div style={appBarStyle}> */}
      {/* {loggedin && <div>
          <button style={signInButtonStyle}>Sign In</button>
          <button style={signUpButtonStyle}>Sign Up</button>
        </div>} */}
      {/* </div> */}
      {/* header search */}

      {/* notification & profile */}
      {/* <NotificationSection /> */}
      {/* <ProfileSection /> */}
    </>
  );
};

Header.propTypes = {
  handleLeftDrawerToggle: PropTypes.func,
};

export default Header;
